module.exports = __webpack_public_path__ + "static/ux_paris_157-a7c8b65ecf91e536f7e8af85770743ca.jpg";